import { createContext } from "react";

/** Pending initial wallet restoration, shared with route guards. */
export const WalletRestoringContext = createContext(false);
